// src/utils/installUtils.js
let deferredPrompt = null;

// Store the install prompt event
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

// Clear the prompt reference after installation
window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
});

export const checkInstallable = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  
  return {
    isInstallable: !!deferredPrompt || (isIOS && isSafari),
    isIOS: isIOS && isSafari,
    isStandalone
  };
};

export const installApp = async () => {
  if (!deferredPrompt) return 'no-prompt';
  
  try {
    // Show the install prompt
    const result = await deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    const choiceResult = await deferredPrompt.userChoice;
    deferredPrompt = null;
    
    return choiceResult.outcome; // 'accepted' or 'dismissed'
  } catch (error) {
    console.error('Install error:', error);
    return 'error';
  }
};